
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Styling any component`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`styled`}</inlineCode>{` method works perfectly on all of your own or any third-party component, as long as they attach the passed `}<inlineCode parentName="p">{`className`}</inlineCode>{` prop to a DOM element.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you are using `}<inlineCode parentName="p">{`react-native`}</inlineCode>{` keep in mind to use `}<inlineCode parentName="p">{`style`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`className`}</inlineCode>{`.`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`// This could be react-router-dom's Link for example
const Link = ({ className, children }) => (
  <a className={className}>
    {children}
  </a>
);

const StyledLink = styled(Link)\`
  color: palevioletred;
  font-weight: bold;
\`;

render(
  <div>
    <Link>Unstyled, boring Link</Link>
    <br />
    <StyledLink>Styled, exciting Link</StyledLink>
  </div>
);
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`You can also pass tag names into the `}<inlineCode parentName="p">{`styled()`}</inlineCode>{` factory call, like so: `}<inlineCode parentName="p">{`styled("div")`}</inlineCode>{`. In fact, the `}<inlineCode parentName="p">{`styled.tagname`}</inlineCode>{` helpers are just aliases that do the same.`}</p>
    </blockquote>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;